module.exports = __webpack_public_path__ + "img/detailJd.14b2b7b7.png";